import { render, staticRenderFns } from "./UserMenuSlideItem.vue?vue&type=template&id=1d5ffbcc&scoped=true&"
import script from "./UserMenuSlideItem.vue?vue&type=script&lang=js&"
export * from "./UserMenuSlideItem.vue?vue&type=script&lang=js&"
import style0 from "./UserMenuSlideItem.vue?vue&type=style&index=0&id=1d5ffbcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5ffbcc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VList,VMenu,VRow,VSlideItem,VSpacer})
